class ScrollService {

	private state = { window: { scrollY: 0 } };

	get window () {
		return this.state.window;
	}

	storeWindowScroll () {
		this.state.window.scrollY = window.scrollY;
	}

	setPreviousWindowScroll () {
		window.scrollTo(0, this.state.window.scrollY);
	}

}

const scrollServiceSingleton = new ScrollService();

export default function useScrollService () {
	return scrollServiceSingleton;
}


